module.exports = __webpack_public_path__ + "img/beeldschermbril-evolutie.1360dc3a.svg";